import { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ProgressBar from "react-bootstrap/ProgressBar";
import moment from "moment";
import _ from "lodash";
import Loader from "../Loader/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import SelectOption from "../AssignModal/SelectOption";
import ChooseTeammate from "../AssignModal/ChooseTeammate";
import ChooseTeams from "../AssignModal/ChooseTeams";
import CreateTeam from "../AssignModal/CreateTeam";
import CreateteamOptions from "../AssignModal/CreateteamOptions";
import CoursesAssign from "../AssignModal/CoursesAssign";
import ChoosePeople from "../AssignModal/ChoosePeople";
import SelectpeopleOptions from "../AssignModal/SelectpeopleOptions";
import GenerateaReport from "../AssignModal/GenerateaReport";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentView,
  setJoyRideReq,
} from "../../redux/assignCourse/actions";
import AssignCourseModal from "../modal/AssignCourseModal";
import CONFIG from "../../utils/config";
import { useParams } from "react-router-dom";
import {
  checkContentAccess,
  checkContentAccessClear,
  getActiveHeader,
} from "../../redux/home/actions";
import {
  SessionKeys,
  convertHoursToMins,
  convertTimeFormat,
  getAssetButtonName,
  getProcureInfo,
  getStepIndex,
} from "../../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import {
  getAssignBrokerCourse,
  getAssignCourse,
  getCourseDetailEcom,
  getCourseDetailEcomClear,
  getModuleListing,
  getModuleListingBroker,
  getModuleListingClear,
  getModuleListingClearBroker,
  getSelectedCatId,
} from "../../redux/courses/actions";
import BackButton from "../Layouts/BackButton";
import ShimmerModuleListing from "../Layouts/ShimmerModuleListing";
import ShimmerCardBody from "../Layouts/ShimmerCardBody";
import ShimmerModuleLaunch from "../Layouts/ShimmerModuleLaunch";
import ImageComponent from "../Layouts/ImageComponent";
import BreadCrumbComponent from "../NewDesign/Misc/BreadCrumb/BreadCrumbComponent";
import RightPanelComponent from "../NewDesign/DetailPage/DetailPageRightPanel/RightPanelComponent";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import ModuleCardComponent from "./ModuleCardComponent";
import DetailLearnDiscussComponent from "../NewDesign/DetailPage/DetailLearnDiscuss/DetailLearnDiscussComponent";
import CartBandComponent from "../NewDesign/DetailPage/CartBand/CartBandComponent";
import CartPopUpComponent from "../NewDesign/DetailPage/CartPopUp/CartPopUpComponent";
import { getCourseDetail } from "../../redux/product/actions";
import API_LIST from "../../utils/apiList";
import { faLaptopHouse } from "@fortawesome/free-solid-svg-icons";
import { routeList } from "../../utils/routeList";
import { isAndroid, isIOS } from "react-device-detect";
import useLogin from "../../custom-hooks/useLogin";
import { useTranslation } from "react-i18next";
const ModuleSectionB2C = (props) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const { t } = useTranslation();
  const toggleMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };
  const closeMenu = () => {
    setIsOpenMenu(false);
  };
  const {
    navigateToDetails,
    moduleListData,
    isLoading,
    setIsLoading,
    isMobile,
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { courseId } = useParams();
  const { isLoggedIn } = useLogin();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(
    sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES"
      ? "{}"
      : decodedString,
  );

  const source = paramsReq.source;
  const cid = paramsReq.cid;
  const from = paramsReq.from;
  const lp_id = paramsReq.lp_id;
  const provider_id = paramsReq?.provider_id;
  const provider_name = paramsReq?.provider_name;
  const is_home = paramsReq?.is_home;
  const from_sub = paramsReq?.from_sub;

  // const source = params.get("source");
  // const cid = params.get("cid");
  // const from = params.get("from")
  // const lp_id = params.get("lp_id")
  const currentView = useSelector((state) => state.assignCourse.current_view);
  const checkContent = useSelector((state) => state.home.checkContent);
  const userRole = useSelector((state) => state.user.role);
  const auth = useSelector((state) => state.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const courseDetailEcom = useSelector(
    (state) => state.courses.courseDetailEcom,
  );
  const availableLPByEntityId = useSelector(
    (state) => state.assignCourse.availableLPByEntityId,
  );
  const categoryListByEntityId = useSelector((state) => state.courses.tagsData);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [moduleData, setModuleData] = useState({ isLoading: true });
  const [show, setShow] = useState(false);
  const [showAssignBtn, setShowAssignBtn] = useState(true);
  const [showContent, setShowContent] = useState(true);
  const [showShimmer, setShowShimmer] = useState(false);
  const [isFree, setIsFree] = useState(false);
  const [role, setRole] = useState("");

  const [breadCrumbData, setBreadCrumbData] = useState([
    {
      name: provider_name
        ? authBroker?.payload?.user?.config?.partner_menu_text !== undefined &&
          !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
          ? authBroker?.payload?.user?.config?.partner_menu_text
          : "Partners"
        : is_home
          ? t("home")
          : from_sub
            ? "Subscription"
            : t("learn"),
      active: false,
      link: "",
      isLoading: false,
    },
    from === "lp" ||
      (from === "bundle" && {
        name: from === "bundle" ? t("combo&Offers") : t("Action Path"),
        active: false,
        link: "",
        isLoading: false,
      }),
    from === "lp" && { name: "-", active: false, link: "", isLoading: true },
    { name: "Courses", active: false, link: "", isLoading: false },
    { name: "-", active: false, link: "", isLoading: true },
  ]);
  const [isOpen, setIsOpen] = useState(false);
  const [headerProdData, setHeaderProdData] = useState({});
  const [detailEcomData, setDetailEcomData] = useState({});
  const [isPaid, setIsPaid] = useState(false);
  const [price, setPrice] = useState(false);
  const [priceText, setPriceText] = useState("");
  const [isInCart, setIsInCart] = useState(false);
  const [isLoadingPriceInfo, setIsLoadingPriceInfo] = useState(true);
  const [hasTeaser, setHasTeaser] = useState(false);
  const [purchasedInfo, setPurchasedInfo] = useState({});
  const [isRightPanel, setIsRightPanel] = useState(true);
  const [isTagAvailable, setIsTagAvailable] = useState(true);

  useEffect(() => {
    console.log("userRole111: ", userRole);
    setRole(userRole);
  }, [userRole]);
  useEffect(() => {
    console.log("AVAILBALE LP", availableLPByEntityId);
    if (
      !(
        localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ||
        localStorage.getItem(SessionKeys.API_TOKEN)
      )
    ) {
      setIsRightPanel(false);
    } else if (!_.isEmpty(availableLPByEntityId)) {
      if (availableLPByEntityId.status === "success") {
        const payload = availableLPByEntityId.payload.payload;
        if (payload?.length > 0) {
          setIsRightPanel(true);
        } else {
          setIsRightPanel(false);
        }
      } else {
        setIsRightPanel(false);
      }

      setIsLoading(false);
    }
  }, [availableLPByEntityId]);
  useEffect(() => {
    console.log("tags data--", categoryListByEntityId);
    if (
      !(
        localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ||
        localStorage.getItem(SessionKeys.API_TOKEN)
      )
    ) {
      setIsTagAvailable(false);
    } else if (!_.isEmpty(categoryListByEntityId)) {
      if (categoryListByEntityId.status === "success") {
        const payload = categoryListByEntityId.payload.payload;
        if (!_.isEmpty(payload) && payload?.length > 0) {
          setIsTagAvailable(true);
        } else {
          setIsTagAvailable(false);
        }
      } else {
        setIsTagAvailable(false);
      }
    }
  }, [categoryListByEntityId]);

  useEffect(() => {
    setTimeout(() => {
      if (_.isEmpty(provider_name)) {
        dispatch(getActiveHeader("learn"));
      }
    }, 1000);
    return () => {
      dispatch(getModuleListingClear());
      dispatch(getModuleListingClearBroker());
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(courseDetailEcom)) {
      setIsLoadingPriceInfo(false);
      if (courseDetailEcom.status === "success") {
        const payload = courseDetailEcom.payload.data;
        console.log("courseDetailEcom", courseDetailEcom, payload);
        if (
          !_.isEmpty(courseDetailEcom) &&
          courseDetailEcom.status === "success"
        ) {
          setIsLoading(false);
          setShowShimmer(false);
          // console.log(courseDetailEcom.payload.data)
          let modulesInfo = _.cloneDeep(courseDetailEcom.payload.data);
          modulesInfo?.modules?.sort(
            (a, b) =>
              parseFloat(a.module_sequence) - parseFloat(b.module_sequence),
          );
          if (!_.isEmpty(modulesInfo)) {
            if (modulesInfo.modules.length > 0) {
              modulesInfo.modules[0].isLock = false;
              for (let [index, modules] of modulesInfo.modules.entries()) {
                modules.isLock =
                  modules.isLock === false ? modules.isLock : true;
                if (modules.progress > 0) {
                  modules.isLock = false;
                  if (index + 1 !== modulesInfo.modules.length)
                    modulesInfo.modules[index + 1].isLock =
                      _.toNumber(modules.progress) === 100 ? false : true;
                }
                if (!isLoggedIn && !modules.is_teaser) {
                  modules.isLock = true;
                }
              }
              for (let modules of modulesInfo.modules) {
                const hour = moment(modules.duration, "hh:mm").hours();
                const min = moment(modules.duration, "hh:mm").minutes();
                if (hour > 0) {
                  modules.durationTime =
                    hour > 1 ? `${hour} hours` : `${hour} hour`;
                }
                if (min > 0) {
                  modules.durationTime =
                    min > 1
                      ? modules.durationTime
                        ? `${modules.durationTime} ${min} minutes`
                        : `${min} minutes`
                      : modules.durationTime
                        ? `${modules.durationTime} ${min} minute`
                        : `${min} minute`;
                }
              }
            }
            setModuleData(modulesInfo);
            // console.log("Modulelisting datas", modulesInfo, source);
          } else {
            setModuleData({});
          }
        }
        let breadCData = [
          {
            name: provider_name
              ? authBroker?.payload?.user?.config?.partner_menu_text !==
                  undefined &&
                !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
                ? authBroker?.payload?.user?.config?.partner_menu_text
                : "Partners"
              : is_home
                ? "Home"
                : from_sub
                  ? "Subscription"
                  : t("learn"),
            active: false,
            link: isMobile
              ? ""
              : provider_name
                ? "/our-partners"
                : is_home
                  ? "/home"
                  : from_sub
                    ? "/subscription"
                    : "/learn/courses?tab=1",
            isLoading: false,
          },
        ];
        let paramsReq = {
          provider_id: provider_id,
          provider_name: provider_name,
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        if (provider_name) {
          breadCData.push({
            name: provider_name,
            active: false,
            link: isMobile ? "" : `/partner-detail?c=${encodedUrl}`,
            isLoading: false,
          });
        }
        if (from === "lp" || from === "bundle") {
          breadCData.push({
            name: from === "bundle" ? t("combo&Offers") : t("Action Path"),
            active: false,
            link: isMobile
              ? ""
              : from === "bundle"
                ? routeList.LEARN_COMBO_PAGE
                : routeList.LEARN_LEARNING_PATH_PAGE,
            isLoading: false,
          });
          breadCData.push({
            name: payload.lp_name,
            active: false,
            link: isMobile ? "" : -1,
            isLoading: false,
          });
        }
        breadCData.push({
          name: t("courses"),
          active: false,
          link: isMobile
            ? ""
            : provider_name
              ? `/partner-detail/courses/?c=${encodedUrl}&tab=1`
              : from === "lp" || from === "bundle"
                ? -1
                : "/learn/courses?tab=1",
          isLoading: false,
        });
        breadCData.push({
          name: payload.courseName,
          active: true,
          link: "",
          isLoading: false,
        });

        setBreadCrumbData(breadCData);
        if (!_.isEmpty(payload) && !_.isEmpty(payload.purchased_info)) {
          const purchased_info = payload.purchased_info;
          console.log("courseDetailEcom", purchased_info);
          if (
            from === "lp" ||
            purchased_info.is_purchased ||
            _.toNumber(purchased_info.selling_price) == 0
          ) {
            setIsPaid(false);
            setPrice(0);
            setPriceText(
              purchased_info.enrolled_text ? purchased_info.enrolled_text : "",
            );
            setPurchasedInfo({});
          } else {
            setIsPaid(true);
            setPriceText(purchased_info.enrolled_text);
            setPrice(_.toNumber(purchased_info.selling_price));
            setPurchasedInfo(purchased_info);
          }
          setIsInCart(payload.is_addtocart);
        }
      }
      dispatch(getCourseDetailEcomClear());
    }
  }, [courseDetailEcom]);

  useEffect(() => {
    console.log(courseId);
    dispatch(
      checkContentAccess({
        module: "checkContentAccess",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          origin: source === "ecom" ? "xsel" : "broker",
          entity_id: source === "ecom" ? courseId : cid,
          entity_type: "courses",
        },
      }),
    );
    // if (!_.isEmpty(authBroker)) {
    //   if (source === "ecom") {
    //     dispatch(
    //       getAssignCourse({
    //         module: "assign-course",
    //         postData: {
    //           user_id: authBroker?.payload?.user.user_id,
    //           course_id: courseId,
    //         },
    //       })
    //     );
    //   }
    // }
    // return (() => {
    // 	dispatch(getModuleListingClear());
    // 	dispatch(getModuleListingClearBroker());
    // })
  }, [dispatch, authBroker]);
  console.log("name---mod", provider_name);

  useEffect(() => {
    if (!_.isEmpty(checkContent)) {
      if (checkContent.status === "success") {
        const data = checkContent.payload.payload;
        if (!_.isEmpty(data)) {
          setIsFree(data.is_free);
          // dispatch(checkContentAccessClear());
        }
      }
    }
  }, [checkContent]);

  useEffect(() => {
    // if (showContent) {
    // if (!_.isEmpty(auth)) {
    setShowShimmer(true);
    if (source === "xsel" || source === "ecom") {
      if (sessionStorage.getItem(SessionKeys.IS_TOUR) !== "YES" || true) {
        dispatch(getModuleListingClear());
        setIsLoading(true);
        // setModuleData({});

        let reqBody = {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: localStorage.getItem(SessionKeys.SESSION_ID),
          entity_id: cid,
          language: activeLanguage ? activeLanguage : "",
        };
        if (from === "lp") {
          reqBody.lp_id = lp_id;
        } else if (from === "bundle") {
          reqBody.bundle_id = lp_id;
        }

        dispatch(
          getCourseDetailEcom({
            URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.COURSE_DETAIL_ECOM}`,
            payload: reqBody,
            method: "post",
            isJSON: true,
            language: activeLanguage ? activeLanguage : "",
          }),
        );
        let user_id = "";
        if (
          !_.isEmpty(auth?.authBroker) &&
          auth?.authBroker?.payload?.user?.user_id
        ) {
          user_id = auth.authBroker?.payload?.user?.user_id;
        }
        // dispatch(
        //   getModuleListing({
        //     module: "getNIITAdminModule",
        //     postData: {
        //       user_id: user_id,
        //       course_id: courseId,
        //     },
        //   })
        // );
      }
    } else {
      dispatch(getModuleListingClearBroker());
      setIsLoading(true);
      // setModuleData({});
      if (sessionStorage.getItem(SessionKeys.IS_TOUR) !== "YES" || true) {
        let payload = {
          module: "get_all_course_modules",
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          courseId: courseId,
          language: activeLanguage ? activeLanguage : "",
        };
        if (from === "lp") {
          payload.lpId = lp_id;
        } else if (from === "bundle") {
          payload.bundle_id = lp_id;
        }

        dispatch(getModuleListingBroker(payload));
      }
    }
    // }
  }, [courseId, activeLanguage]);

  console.log("pid---", provider_id);

  useEffect(() => {
    dispatch(setCurrentView(1));
    if (!_.isEmpty(moduleListData.modules)) {
      setIsLoading(false);
      // moduleListData?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
      setShowShimmer(false);
      let datModule = _.cloneDeep(moduleListData);
      if (datModule.durationUnit === "Hours") {
        datModule.duration = convertHoursToMins(datModule.duration, t);
      }
      datModule.duration = convertTimeFormat(_.toNumber(datModule.duration), false, t);
      datModule.durationUnit = "";
      datModule.isLoading = false;
      let breadCData = [
        {
          name: provider_name
            ? "Partners"
            : is_home
              ? "Home"
              : from_sub
                ? "Subscription"
                : t("learn"),
          active: false,
          link: isMobile
            ? ""
            : provider_name
              ? "/our-partners"
              : is_home
                ? "/home"
                : from_sub
                  ? "/subscription"
                  : "/learn/courses?tab=1",
          isLoading: false,
        },
      ];
      let paramsReq = {
        provider_id: provider_id,
        provider_name: provider_name,
      };
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      if (provider_name) {
        breadCData.push({
          name: provider_name,
          active: false,
          link: isMobile ? "" : `/partner-detail?c=${encodedUrl}`,
          isLoading: false,
        });
      }
      if (from === "lp" || from === "bundle") {
        breadCData.push({
          name: from === "bundle" ? t("combo&Offers") : t("Action Path"),
          active: false,
          link: isMobile
            ? ""
            : from === "bundle"
              ? routeList.LEARN_COMBO_PAGE
              : routeList.LEARN_LEARNING_PATH_PAGE,
          isLoading: false,
        });
        breadCData.push({
          name: datModule.lp_name,
          active: false,
          link: isMobile ? "" : -1,
          isLoading: false,
        });
      }
      breadCData.push({
        name: t("courses"),
        active: false,
        link: isMobile
          ? ""
          : provider_name
            ? `/partner-detail/courses/?c=${encodedUrl}&tab=1`
            : from === "lp" || from === "bundle"
              ? -1
              : "/learn/courses?tab=1",
        isLoading: false,
      });
      breadCData.push({
        name: datModule.courseName,
        active: true,
        link: "",
        isLoading: false,
      });

      setBreadCrumbData(breadCData);

      datModule.course_id = cid;
      // datModule.price = isPaid === 'false' ? price : 0
      datModule.hasTeaser = datModule.is_teaser;
      datModule.isPaid = isPaid;
      datModule.price = price;
      datModule.isLoadingPriceInfo = isLoadingPriceInfo;
      datModule.priceInfo = getProcureInfo(purchasedInfo);
      // datModule.isPaid = isPaid;

      setModuleData(datModule);
    }
  }, [moduleListData, price, isPaid, purchasedInfo]);

  // useEffect(() => {
  //   if (!_.isEmpty(authBroker)) {
  //     const isGuest = authBroker.payload.user.role.includes("guest");
  //     if (!isMobile && sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES") {
  //       let stepIndex = getStepIndex(
  //         "#idModuleDetail",
  //         userRole,
  //         isPremiumUser,
  //         isGuest
  //       );
  //       dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }));
  //     }
  //   }
  // }, [authBroker]);

  const proceedToPurchase = () => {
    console.log("moduledata", moduleData);
    if (source !== "broker") {
      if (isAndroid || isIOS) {
        try {
          let obj = {
            message: "click-on-purchase",
            productId: cid,
            amount: price,
            title: moduleData.courseName,
            provider_name: moduleData.provider.provider_display_name,
            provider_img: moduleData.provider.provider_img,
            enrolledtextAmount: moduleData?.purchased_info?.enrolled_text,
          };
          if (window.callbackHandler != undefined) {
            // window.callbackHandler.postMessage("click-on-purchase");
            window.parent.postMessage(JSON.stringify(obj));
          }
          if (window.webkit != undefined) {
            if (window.webkit.messageHandlers.callbackHandler != undefined) {
              // window.webkit.messageHandlers.callbackHandler.postMessage(
              //   "click-on-purchase"
              // );
              window.parent.postMessage(JSON.stringify(obj));
            }
          }
        } catch (err) {
          console.log("error in sending message");
        }
      }
      setIsOpen(true);
      let tags = [];
      let logoURL = "";
      if (!_.isEmpty(moduleData.provider)) {
        tags.push(moduleData.provider.provider_display_name);
        logoURL = moduleData.provider.provider_img
          ? moduleData.provider.provider_img
          : "";
      }
      tags.push("Course");
      if (!_.isEmpty(moduleData.modules)) {
        tags.push(
          `${moduleData.modules.length} Module${
            moduleData.modules.length > 1 ? "s" : ""
          }`,
        );
      }
      // alert(JSON.stringify(moduleData))
      // if (moduleData.durationUnit === "Hours") {
      //   moduleData.duration = convertHoursToMins(moduleData.duration);
      // }
      // moduleData.duration = convertTimeFormat(_.toNumber(moduleData.duration));
      // moduleData.durationUnit = "";
      if (moduleData.duration) {
        tags.push(`${moduleData.duration}`);
      }
      // tags.push(`${moduleData.views} View${moduleData.views > 1 ? 's' : ''}`)

      let priceInfo = _.cloneDeep(moduleData.priceInfo);
      // alert(JSON.stringify(moduleData))
      console.log(moduleData);
      priceInfo.isAddToCart = moduleData.is_addtocart;
      setHeaderProdData({
        id: cid,
        title: moduleData.courseName,
        logoURL: logoURL,
        logoAltText: "CD",
        bannerURL: moduleData.thumbnail,
        tagsArray: tags,
        description: moduleData.coursedescription,
        duration: `${moduleData.duration} ${moduleData.durationUnit}`,
        view: 0,
        price: price,
        isPaid: isPaid,
        priceInfo: priceInfo,
        priceText: `Price:  ${moduleData?.purchased_info?.currency_symbol}${moduleData?.purchased_info?.selling_price} `,
      });
    }
  };

  return (
    <>
      {isLoading || _.isEmpty(moduleData) ? (
        <></>
      ) : moduleData?.modules && moduleData?.modules.length > 0 ? (
        moduleData?.modules?.map((item, index) => {
          return (
            <section className="money-section">
              <div className="assssbanner">
                <img
                  src="/images/finwell-img/Header.png"
                  alt="banner"
                  width="1440"
                  height="244"
                  className="img-fluid"
                />
              </div>
              <div className="money-section-inner">
                <div class="card-money">
                  <h1 aria-label={item?.title}>{item?.title}</h1>
                  <div
                    className="mb-0 card-deic"
                    aria-label={item?.desc?.replace(/<[^>]+>/g, "")} // strip HTML tags
                    dangerouslySetInnerHTML={{ __html: item?.desc }}
                  ></div>
                  <div className="btnsec d-flex gap-1 align-items-center justify-content-between mt-4">
                    <button
                      className="session-btn mt-0"
                      tabIndex={0}
                      aria-label="Start"
                      onClick={() => {
                        navigateToDetails(item.title, item.progress, item);
                      }}
                    >
                      Start
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.58 7.50399L9.076 1.98399C8.98 1.88799 8.932 1.77065 8.932 1.63199C8.932 1.49332 8.98 1.37599 9.076 1.27999C9.172 1.18399 9.28933 1.13599 9.428 1.13599C9.56667 1.13599 9.684 1.18399 9.78 1.27999L16.5 7.99999L9.78 14.72C9.684 14.816 9.56667 14.864 9.428 14.864C9.28933 14.864 9.172 14.816 9.076 14.72C8.98 14.624 8.932 14.5067 8.932 14.368C8.932 14.2293 8.98 14.112 9.076 14.016L14.58 8.49599H0.996C0.857333 8.49599 0.74 8.44799 0.644 8.35199C0.548 8.25599 0.5 8.13865 0.5 7.99999C0.5 7.86132 0.548 7.74399 0.644 7.64799C0.74 7.55199 0.857333 7.50399 0.996 7.50399H14.58Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                    {moduleData?.asset_id === "2" && (
                      <button
                        className="border-0 link-btn"
                        tabIndex={0}
                        aria-label="Take assessment later"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Take assessment later
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </section>
          );
        })
      ) : (
        ""
      )}

      {false && (
        <section className="bannersection-sec">
          <div className="bannersection bgba">
            {showShimmer ? (
              <ShimmerScreen case={"rect"} width={"100%"} height={"358px"} />
            ) : (
              <div className="bannerrimg">
                <img
                  src={moduleData?.banner}
                  alt="Banner"
                  className="banner-image"
                />
              </div>
            )}

            <div className="container posr">
              <div className="container-chart">
                <div className="box-progress">
                  {false && (
                    <div
                      className="circularProgress"
                      style={{
                        width: 150,
                        height: 150,
                        position: "relative",
                      }}
                    >
                      <CircularProgressbar
                        value={moduleData?.progress}
                        styles={buildStyles({
                          pathColor:
                            moduleData?.progress < 100
                              ? `var(--color-element-1, #415385)`
                              : "var(--color-element-1, #415385)", //FF9700=yellow
                          trailColor: "#EAECF0",
                        })}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "0",
                          bottom: "0",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          width: "150px",
                          textAlign: "center",
                        }}
                      >
                        {moduleData?.progress > -1 ? (
                          <>
                            <div className="comtext">
                              {t("Completed so far")}
                            </div>
                            <strong className="percent">{`${moduleData?.progress?.toFixed(
                              0,
                            )}%`}</strong>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <CartBandComponent
              showTagLine={
                source === "broker" ? false : isPaid || !_.isEmpty(priceText)
              }
              showBtn={source === "broker" ? false : isPaid}
              showShareIcon={true}
              tagLine={priceText}
              rightTagLine={`${
                purchasedInfo.offer_ends_on_text
                  ? purchasedInfo.offer_ends_on_text
                  : ""
              }`}
              btnName={t("Purchase to unlock")}
              btnAction={() => proceedToPurchase()}
            />
          </div>
          {false && (
            <div className="container">
              <BreadCrumbComponent crumbList={breadCrumbData} />
            </div>
          )}
          <div className="container">
            <div className="row">
              {false && (
                <div className="col-xl-2">
                  <div className="leftmenusec sec-I">
                    <div
                      className="d-xl-none btn-filter-mob"
                      onClick={toggleMenu}
                    >
                      Menu
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
                          fill="#2D2D2D"
                        />
                      </svg>
                    </div>
                    <ul className={`sidebar ${isOpenMenu ? "openMenu" : ""}`}>
                      <span
                        className="close-menu d-xl-none cursor-pointer"
                        onClick={toggleMenu}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M15.1484 13.5781C15.5703 14.0469 15.5703 14.75 15.1484 15.1719C14.6796 15.6406 13.9765 15.6406 13.5546 15.1719L8.02344 9.59375L2.44532 15.1719C1.97656 15.6406 1.27344 15.6406 0.851559 15.1719C0.382814 14.75 0.382814 14.0469 0.851559 13.5781L6.42969 8L0.851559 2.42188C0.382814 1.95312 0.382814 1.25 0.851559 0.828125C1.27344 0.359375 1.97656 0.359375 2.39844 0.828125L8.02344 6.45312L13.6015 0.875C14.0234 0.40625 14.7265 0.40625 15.1484 0.875C15.6172 1.29688 15.6172 2 15.1484 2.46875L9.57034 8L15.1484 13.5781Z"
                            fill="#2D2D2D"
                          />
                        </svg>
                      </span>
                      <li className="activemenu" onClick={closeMenu}>
                        Intro
                      </li>
                      {moduleData?.modules && moduleData?.modules.length > 0
                        ? moduleData?.modules?.map((item, index) => {
                            return (
                              <li
                                className="cursor-pointer"
                                onClick={() => {
                                  closeMenu();
                                  window.scrollTo({
                                    top:
                                      document.getElementById(
                                        `module-crs-${item.module_id}`,
                                      ).offsetTop - 100,
                                    left: 0,
                                    behavior: "smooth",
                                  });
                                }}
                              >
                                {"Module " + (index + 1)}{" "}
                                {item.progress < 100 && (
                                  <span
                                    className={`lock-bar ${
                                      item.isLock ? "lock-bar" : "unlock-bar"
                                    }`}
                                  ></span>
                                )}
                              </li>
                            );
                          })
                        : ""}
                    </ul>
                  </div>
                </div>
              )}
              <div
                className={
                  isRightPanel || isTagAvailable || role === "manager" || true
                    ? "col-xl-6"
                    : "col-xl-10"
                }
              >
                <div id="idModuleDetail" className="contsection sec-II">
                  <DetailLearnDiscussComponent
                    id={cid}
                    code={courseId}
                    type={"course"}
                    source={source}
                    showLearn={true}
                    showDiscuss={true}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    learnData={moduleData}
                    onLearnClick={navigateToDetails}
                    isMobile={isMobile}
                  />
                </div>
              </div>

              {(isRightPanel || isTagAvailable || role === "manager" || true) &&
                false && (
                  <div className="col-xl-4">
                    <RightPanelComponent
                      id={cid}
                      parentName={"course"}
                      code={courseId}
                      moduleData={moduleData}
                      type={"course"}
                      source={source}
                      isMobile={isMobile}
                      isRightPanel={isRightPanel}
                      isTagAvailable={isTagAvailable}
                      from={"module"}
                    />
                  </div>
                )}
            </div>
          </div>
        </section>
      )}
      <CartPopUpComponent
        entityType={"course"}
        isOpen={isOpen}
        productData={headerProdData}
        closeAction={() => setIsOpen(false)}
        isSubscription={false}
        setMainPageLoading={setIsLoading}
        isMobile={isMobile}
      />
    </>
  );
};

export default ModuleSectionB2C;
